var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-mask",class:{ 'mask-not-visible': _vm.visible === false }},[_c('div',{staticClass:"info-wrapper"},[_c('div',{staticClass:"info-items"},[_c('div',{staticClass:"info-msg"},[_vm._v(_vm._s(_vm.message))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }